var React = require('react');

function Message (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.5 12L2 21","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20 12L31.5 21","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":1}),React.createElement("rect",{"x":"2","y":"2","width":"30","height":"20","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M3 3C3 3 16.5 14 17 14C17.5 14 31 3 31 3","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":3})]);
}

Message.defaultProps = {"width":"34","height":"24","viewBox":"0 0 34 24","fill":"none"};

module.exports = Message;

Message.default = Message;
